import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail'
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm'
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext'
import { ChainList } from '@/skdr/entities/job/ChainList'
import { RunList } from '@/skdr/entities/run/RunList'

export const JobDetail = () => {

  const { entityObj} = useEntityMgr();
  
  const tabSpecs = [
    { id: 'info', label: 'Info', content: <EntityForm /> },
    { id: 'job', label: 'Chain', disabled: !(entityObj.type === 'CHAIN'), content: <ChainList jobId={entityObj.id} />, },
    { id: 'runList', label: 'Runs', content: <RunList jobId={entityObj.id}/> }
  ]
    
  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )

}